import React from 'react';
import { StaffRole } from '../types';
import { MemberStatus, STATUS_LABEL } from './helpers';

export const StatusPill: React.FC<{ status: MemberStatus; online?: boolean }> = ({ status, online }) => (
  <span className={'admin-panel__spill admin-panel__spill--' + status}>
    <span className="admin-panel__spill-dot" aria-hidden="true" />
    {STATUS_LABEL[status]}
    {online && status === 'active' ? <span className="admin-panel__spill-extra">en ligne</span> : null}
  </span>
);

export const RoleChip: React.FC<{ role: StaffRole | null; empty?: string }> = ({ role, empty = 'Aucun rôle' }) =>
  role ? (
    <span className="admin-panel__rolechip" title={role.description || role.name}>
      <span className="admin-panel__swatch" style={{ background: role.color }} aria-hidden="true" />
      {role.name}
    </span>
  ) : (
    <span className="admin-panel__rolechip admin-panel__rolechip--none">{empty}</span>
  );
